import { Component, model, output, signal } from '@angular/core';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-countdown-timer',
  templateUrl: './countdown-timer.component.html',
  styleUrls: ['./countdown-timer.component.scss'],
})
export class CountdownTimerComponent {
  ExpiredTime = model(120);
  RaiseExpiredTime = output<boolean>();
  seconds = signal<number | undefined>(undefined);
  minutes = signal<number | undefined>(undefined);
  private countdown$!: Subscription;

  handleTime() {
    this.minutes.set(Math.floor(this.ExpiredTime() / 60));
    this.seconds.set(this.ExpiredTime() % 60);
  }

  ngOnInit() {
    this.handleTime();
    this.countdown$ = interval(1000).subscribe(() => {
      if (this.ExpiredTime() > 0) {
        this.ExpiredTime.update((value) => value - 1);
        this.handleTime();
        if (this.ExpiredTime() === 0) {
          this.RaiseExpiredTime.emit(true);
        }
      }
    });
  }

  ngOnDestroy() {
    this.countdown$.unsubscribe();
  }
}
